<template>
  <SimpleDataTable
    :title="'Borçlu Alıcı Listesi'"
    :description="''"
    :dataList="top10CurrentBorrowerList"
    :dataHeaders="top10CurrentBorrowerListHeaders"
    :loading="top10CurrentBorrowerListLoading"
    :pagination-status="true"
    :pagination-length="maxPage"
    @page-change="handlePageChange"
  >
  </SimpleDataTable>
</template>

<script>
import SimpleDataTable from "@/components/dashboard/SimpleDataTable";
import { mapActions, mapState } from "vuex";
import { numberConverter } from "../../../../helpers";

export default {
  name: "Top10BorcluCariListesi",
  components: {
    SimpleDataTable,
  },
  props: {
    dashboardFilterCurrentCodeProp: {
      type: String,
      default: null,
    },
    dashboardFilterSalesPersonCodeProp: {
      type: String,
      default: null,
    },
    dashboardFilterReportDbNameProp: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  mounted() {
    this._fetchBorrowerCurrentList();
  },
  data() {
    return {
      maxPage: null,
      currentPage: 1,
      top10CurrentBorrowerList: [],
      top10CurrentBorrowerListHeaders: [],
      top10CurrentBorrowerListLoading: false,
    };
  },
  methods: {
    ...mapActions("dashboard", ["fetchBorrowerCurrentList"]),
    numberConverter,
    async handlePageChange(newPage) {
      this.currentPage = newPage;
      await this._fetchBorrowerCurrentList();
    },
    _fetchBorrowerCurrentList() {
      this.fetchBorrowerCurrentList({
        params: {
          userId: this.user.UserId,
          pageNumber: this.currentPage,
          pageSize: 10,
          ...(!(
            this.dashboardFilterCurrentCodeProp === "" ||
            this.dashboardFilterCurrentCodeProp == null
          ) && { currentCode: this.dashboardFilterCurrentCodeProp }),
          ...(!(
            this.dashboardFilterSalesPersonCodeProp === "" ||
            this.dashboardFilterSalesPersonCodeProp == null
          ) && { salesPersonCode: this.dashboardFilterSalesPersonCodeProp }),
          ...(!(
            this.dashboardFilterReportDbNameProp === "" ||
            this.dashboardFilterReportDbNameProp == null
          ) && { reportDbName: this.dashboardFilterReportDbNameProp }),
        },
        body: {},
      }).then((result) => {
        if (result && result.data.success) {
          this.top10CurrentBorrowerListHeaders = [
            {
              key: "currentCode",
              label: "Cari Kodu",
              sortable: false,
              class: "align-middle",
            },
            {
              key: "currentName",
              label: "Cari Adı",
              sortable: false,
              class: "align-middle",
            },
            {
              class: "text-center align-middle",
              key: "balance",
              label: "Bakiye",
              sortable: false,
            },
            {
              class: "text-center",
              key: "currencyBalance",
              label: "Dövizli Bakiye",
              sortable: false,
            },
          ];
          this.top10CurrentBorrowerList = result.data.data;
          this.maxPage = result.data.totalPages;
          this.top10CurrentBorrowerList.map(
            (item) => (item.balance = numberConverter(item.balance))
          );
          this.top10CurrentBorrowerList.map(
            (item) =>
              (item.currencyBalance = numberConverter(item.currencyBalance))
          );
        }
      });
    },
  },
  watch: {
    dashboardFilterCurrentCodeProp(newVal) {
      newVal;
      this._fetchBorrowerCurrentList();
    },
    dashboardFilterSalesPersonCodeProp(newVal) {
      newVal;
      this._fetchBorrowerCurrentList();
    },
    dashboardFilterReportDbNameProp(newVal) {
      newVal;
      this._fetchBorrowerCurrentList();
    },
  },
};
</script>

<style scoped></style>
